import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetAssignmentTemplates = () => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.AssignmentTemplates], () => api.base
        .get(`${config.appUrls.api}/api/AssignmentTemplate/Get`)
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
